import { createBrowserRouter } from "react-router";

import MainFrame from "@/Layout/Layout";
import Notfound from "./pages/Notfound/NotFoundView";
import HomeView from "@/pages/home/HomeView";
import ContactUsView from "@pages/contact/ContactUsView";
import PortfolioView from "@pages/portfolio/PortfolioView";
import IndividualProductView from "@pages/portfolio/IndividualProductView";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeView />,
  },
  {
    path: "/contact-us",
    element: <ContactUsView />,
  },
  {
    path: "/portfolio",
    element: <PortfolioView />,
  },
  {
    path: "/portfolio/:productId",
    element: <IndividualProductView />,
  },
  {
    path: "*",
    element: (
      <MainFrame>
        <Notfound />
      </MainFrame>
    ),
  },
]);

export default router;
